import React from "react";
import ItemList from "../components/ItemList";

function Paninis() {
  const IMG_PANINNI =
    "https://i.pinimg.com/564x/9e/74/89/9e7489eef92a52b00185b978e46d9aba.jpg";

  const INCLUDED = "queso, tomate, cebolla y orégano";
  const SAUCES = "Salsas a elegir.";

  const paninis = [
    { key: "ternera", name: "Paninni Ternera", main: "Carne de ternera" },
    { key: "pollo", name: "Paninni Pollo", main: "Carne de pollo" },
    { key: "pavo", name: "Paninni Pavo", main: "Lonchas de pavo" },
    { key: "mixto", name: "Paninni Mixto", main: "Carne de ternera y pollo" },
    { key: "salami", name: "Paninni Salami", main: "Salami" },
    { key: "hotdog", name: "Paninni Hot Dog", main: "Salchichas" },
    { key: "atun", name: "Paninni Atún", main: "Atún con aceitunas" },
  ].map((p) => ({
    ...p,
    price: "5,00€",
    img: IMG_PANINNI,
    description: `${p.main}. ${INCLUDED}. ${SAUCES}.`,
    menuPrice: "8,00€",
    menuIncludes: "Patatas + 1 bebida",
  }));

  return (
    <div id="paninis" className="container mx-auto mt-8 px-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">Paninis</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {paninis.map((menu) => (
          <ItemList
            key={menu.key}
            name={menu.name}
            description={menu.description}
            price={menu.price}
            img={menu.img}
            menuPrice={menu.menuPrice}
            menuIncludes={menu.menuIncludes}
          />
        ))}
      </div>
    </div>
  );
}

export default Paninis;